module.exports = require("././angular.js");


//////////////////
// WEBPACK FOOTER
// angular (bower component)
// module id = 405
// module chunks = 1